<template>
  <div class="d-flex align-items-center">
    <el-checkbox class="mr-2 mb-0" v-model="checked"></el-checkbox>
    <small v-if="checked">Vous avez lu la notification</small>
    <small v-else
      >Cochez la case pour indiquer que vous avez lu la notification</small
    >
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'mayday-web-notification-modal-item-checkbox',
  props: {
    notification: Object,
  },
  methods: {
    ...mapActions('webKnowledgeModule', ['readAgentNotification']),
  },
  computed: {
    checked: {
      get() {
        return this.notificationsRead
          ? this.notificationsRead.includes(this.notification.id)
          : false;
      },
      set() {
        this.readAgentNotification(this.notification.id);
      },
    },
    ...mapState('webKnowledgeModule', ['notificationsRead']),
  },
};
</script>
